import React from 'react'

export const PauseIcon = () => (
  <svg viewBox="0 0 32 32">
    <rect height="24" width="8" x="20" y="4" />
    <rect height="24" width="8" x="4" y="4" />
  </svg>
)

export const PlayIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M3.9,18.9V5.1c0-1.6,1.7-2.6,3-1.8l12,6.9c1.4,0.8,1.4,2.9,0,3.7l-12,6.9C5.6,21.5,3.9,20.5,3.9,18.9z" />
  </svg>
)
